import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  HStack,
  VStack,
  IconButton,
  Spinner,
} from "@chakra-ui/react";
import { decryptResponse } from "../../../allApi/interceptorsApiCall";
import { useDispatch } from "react-redux";
import { waveflowToolsAdd } from "../../../redux/reducer/waveFlow";
import apiClient from "../../../allApi/interceptorsApiCall";
import { useCustomTost } from "../../../utiils/useCustomTost";

const ToolForm = ({ onClose }) => {
  const [toolLoading, setToolLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    secrets: [{ key: "", value: "" }],
  });
  const [file, setFile] = useState(null);
  const toast = useCustomTost();
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSecretChange = (index, field, value) => {
    const newSecrets = [...formData.secrets];
    newSecrets[index][field] = value;
    setFormData((prevData) => ({ ...prevData, secrets: newSecrets }));
  };

  const addSecret = () => {
    setFormData((prevData) => ({
      ...prevData,
      secrets: [...prevData.secrets, { key: "", value: "" }],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setToolLoading(true);

    const apiUrl = "/add-tools";
    const form = new FormData();

    form.append("name", formData.name);
    form.append("description", formData.description);

    if (file) {
      form.append("file", file);
    }

    formData.secrets.forEach((secret, index) => {
      form.append(`secrets[${index}][key]`, secret.key);
      form.append(`secrets[${index}][value]`, secret.value);
    });

    try {
      const response = await apiClient.post(apiUrl, form);
  
      // decrypt response
      const decryptedData = decryptResponse(response.data);
  
      if (decryptedData) {
        dispatch(waveflowToolsAdd(decryptedData));
        onClose();
        toast("Success!", "Form submitted successfully", "success");
      }
  
    } catch (error) {
      console.error("Error submitting form:", error);
      toast("Error!", error?.message || "Something went wrong", "error");
    } finally {
      setToolLoading(false);
    }
  };

  return (
    <Box p={8} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <form onSubmit={handleSubmit}>
        <FormControl isRequired mb={6}>
          <FormLabel>Name</FormLabel>
          <Input
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Enter tool name"
          />
        </FormControl>

        <FormControl isRequired mb={6}>
          <FormLabel>Description</FormLabel>
          <Textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            placeholder="Enter tool description"
          />
        </FormControl>

        {/* <FormControl mb={4}>
          <FormLabel>Secrets</FormLabel>
          <VStack spacing={2}>
            {formData.secrets.map((secret, index) => (
              <HStack key={index} spacing={2} w={"100%"}>
                <Input
                  placeholder="Key"
                  value={secret.key}
                  onChange={(e) =>
                    handleSecretChange(index, "key", e.target.value)
                  }
                />
                <Input
                  placeholder="Value"
                  type="password"
                  value={secret.value}
                  onChange={(e) =>
                    handleSecretChange(index, "value", e.target.value)
                  }
                />
              </HStack>
            ))}
          </VStack>
          <Button mt={2} size="sm" leftIcon={<AddIcon />} onClick={addSecret}>
            Add Secret
          </Button>
        </FormControl> */}

        <FormControl isRequired mb={6}>
          <FormLabel>Upload Python File</FormLabel>
          <Input type="file" accept=".py" onChange={handleFileChange} />
        </FormControl>

        <Button type="submit" colorScheme="blue" w="full">
          {toolLoading ? <Spinner /> : "Save"}
        </Button>
      </form>
    </Box>
  );
};

export default ToolForm;
